/**
 * API route paths shared between backend and frontend.
 * Use these constants instead of hardcoding strings.
 */
export const API_ROUTES = {
  chat: '/api/chat',
  health: '/api/health',
  auth: '/api/auth',
  users: '/api/users',
  groups: '/api/groups',
  groupOptions: '/api/groups/options',
  me: '/api/me',
  contact: '/api/contact',
  requests: '/api/requests',
  notifications: '/api/notifications',
  contacts: '/api/contacts',
  organizations: '/api/organizations',
  organizationOptions: '/api/organizations/options',
  demos: '/api/demos',
  proposals: '/api/proposals',
  projects: '/api/projects',
  projectOptions: '/api/projects/options',
  documents: '/api/documents',
} as const

/** Anteprima come gruppo sui dati reali: gruppo simulato e organizzazione scelta (vuota = nessuna). Solo GET. */
export const PREVIEW_HEADERS = { group: 'x-preview-group', organization: 'x-preview-organization' } as const

export type ApiRoute = (typeof API_ROUTES)[keyof typeof API_ROUTES]

/** Default backend port used in development. */
export const DEFAULT_API_PORT = 3001

/** Default frontend port used in development. */
export const DEFAULT_FRONTEND_PORT = 3000
